import React, { useState, useEffect } from "react";
import "./signin.css";
// import axios from "axios";
import { useNavigate } from "react-router-dom";
import { API } from "../../backend";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
// import { useDispatch, useSelector } from "react-redux";
// import { addProduct } from "../../redux/actions/cartAction";
import { CommonPopup } from "../commonComponents/popUp/PopUp";
// import jwt_decode from "jwt-decode";
import loginPopupImg from "../../images/popups/loginPopup.svg";
// components
// import { userInfo, getUser } from "../../redux/actions/userAction";
// images
// import { Link } from "react-router-dom";
import logo from "./../../images/EhsLogo2.png";
import { useForm } from "react-hook-form";
import { useSelector } from "react-redux";

const ForgetPassword = () => {
  const topView = () => {
    window.scrollTo({ top: 0 });
  };
  topView();
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  // let newUser;

  const [popup, setPopup] = useState(false);
  const getState = useSelector((state) => state);

   
  // let data = useSelector((state) => state.user);
  // const dispatch = useDispatch();

  // useEffect(()=>{
  //   dispatch(getUser());
  // })
  const navigate = useNavigate();
  useEffect(() => {
    if (localStorage.getItem("myuser")) {
      navigate("/");
    }
  }, []);
  //   let tokenn = JSON.parse(localStorage.getItem("myuser")).token;
  const handleReset = async (data) => {
    let emailid = data.email;
    let password = data.password;
    console.log(email, password);
    const res = await fetch(`${API}auth/resetPassword`, {
      method: "POST",
      body: JSON.stringify({ emailid, password }),
      headers: {
        "Content-Type": "application/json",
        // "x-access-token": `${tokenn}`,
        
      },
      
    });
    const dataa = await res.json();
    console.log(dataa);
    toast.success(dataa.message, {
      position: "top-center",
      autoClose: 2000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      closeButton: false,
    });
    function redirect() {
      navigate("/signin");
    }
    if (dataa.message) {
      setTimeout(redirect, 2000);
    }

    // let newUser = {
    //   email: email,
    //   password: password,
    // };
    // try {
    //   dispatch(userInfo(newUser));
    // } catch (err) {
    //   //console.log(err);
    // }
  };

  //   useEffect(() => {
  //     if (data) {
  //       if (data.loginResponse === 1) {
  //         //console.log("yes loogees in successfully");
  //         localStorage.setItem(
  //           "myuser",
  //           JSON.stringify({
  //             token: data.userDetail.session_token,
  //             id: data.userDetail._id,
  //             email: email,
  //           })
  //         );
  //         dispatch(getUser());

  //         setPopup(true);
  //         // navigate(`/thankyou?res=${data.loginResponse}`);
  //       } else if (data.loginResponse === 0) {
  //         toast.error(data.responseMessage, {
  //           position: "bottom-center",
  //           autoClose: 2000,
  //           hideProgressBar: false,
  //           closeOnClick: true,
  //           pauseOnHover: true,
  //           draggable: true,
  //           progress: undefined,
  //           closeButton: false,
  //         });
  //       }
  //     }
  //   }, [data]);
  //   const handleCallbackResponsez = async (response) => {
  //     // console.log("token ", response.credential);
  //     let userObject = jwt_decode(response.credential);
  //     const res = await fetch(`${API}auth/loginwithgoogle`, {
  //       method: "POST",
  //       body: JSON.stringify(userObject),
  //       headers: { "Content-Type": "application/json" },
  //     });
  //     const dataa = await res.json();
  //     console.log(dataa);
  //     if (dataa.success === 1 && dataa.message === 1) {
  //       let newUser = {
  //         email: userObject.email,
  //         password: userObject.sub,
  //       };

  //       dispatch(userInfo(newUser));
  //       setPopup(true);
  //     } else if (dataa.success === 1 && dataa.message === 2) {
  //       try {
  //         newUser = {
  //           userName: userObject.name,
  //           email: userObject.email,
  //           password: userObject.sub,
  //           // phone: userObject.phone,
  //           google: true,
  //         };

  //         // signUp(userObject,true);
  //       } catch (error) {
  //         console.log(error);
  //       }
  //     }

  //     console.log(userObject, "ai");
  //     // setUser(userObject);
  //     // document.getElementById("signInDiv").hidden = true;
  //   };
  //   useEffect(() => {
  //     /*global google*/
  //     google.accounts.id.initialize({
  //       client_id:
  //         "685827706441-6gsel3e5uq4edb9qk9ui9nthf7bevjac.apps.googleusercontent.com",
  //       callback: handleCallbackResponsez,
  //     });
  //     google.accounts.id.renderButton(document.getElementById("signInDiv"), {
  //       scope: "profile email",
  //       width: 300,
  //       height: 50,
  //       longtitle: true,
  //       theme: "dark",
  //       // 'onsuccess': onSuccess,
  //       // 'onfailure': onFailure
  //     });
  //     google.accounts.id.prompt();
  //   }, []);

  return (
    <>
      <div className="signinContainer">
        <ToastContainer
          position="bottom-left"
          autoClose={3000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
        />
        <div className="formContainer2 signInform-box flex items-center justify-center flex-col mt-4 ">
          <div className="logoContainer mb-5">
            <div className="logo  mt-7 ">
              <img src={logo} alt="Ehs-logo" className="w-[125px]" />
            </div>
            <p className="mb-1 text-2xl text-[#003459] font-['Roboto] mt-3">
              Change your password
            </p>
          </div>
          <form className="form mb-4   flex gap-3 justify-center items-center " onSubmit={handleSubmit(handleReset)}>
            <input
              type="email"
              placeholder="Email"
              onChange={(e) => {
                setEmail(e.target.value);
              }}
              {...register("email", { required: "Email is required" })}
              className="border rounded-[4px] flex items-center "
            />
            {errors.email && (
              <p className="text-red-400 text-xs">{errors.email?.message}</p>
            )}
            {/* <input
              type="password"
              placeholder="Password"
              value={password}
              className="border rounded-[4px]"
              onChange={(e) => {
                setPassword(e.target.value);
              }}
              required
            /> */}
            <input
              type="password"
              placeholder="Password"
              {...register("password", {
                required: "Password is required",
                minLength: {
                  value: 6,
                  message: "Password must be 6 characters or longer",
                },
              })}
              className="border rounded-[4px]"
              onChange={(e) => {
                setPassword(e.target.value);
              }}
            />
            {errors.password && (
              <p className="text-red-400 text-xs mb-1">
                {errors.password?.message}
              </p>
            )}
            <input
              type="password"
              placeholder="Confirm Password"
              value={confirmPassword}
              className="border rounded-[4px] mb-1"
              onChange={(e) => {
                setConfirmPassword(e.target.value);
              }}
              required
            />
            {password !== confirmPassword && (
              <p className="text-sm text-red-400 mb-1">
                Password did not match!
              </p>
            )}
            <input type="submit" value="Continue" className="submitBtn mt-3" />
            <div id="errorBox"></div>
          </form>
        </div>
      </div>
      <CommonPopup
        heading="Great!"
        image={loginPopupImg}
        desc="You have successfully changed your password."
        secondBtn={true}
        // setMyPopup={setPopup}
        popup={popup}
      />
    </>
  );
};

export default ForgetPassword;
